import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { ColumnPayload, UserSettings, UserSettingsResponse } from '../../../types/User';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const updateUserSettings = async (formData: Partial<UserSettings>): Promise<UserSettingsResponse> => {
  const response = await CustomAxios.put('user-settings', { settings: formData });
  return response.data;
};

export function useUpdateUserSettings() {
  return useMutation({
    mutationFn: (formData: Partial<UserSettings>) => updateUserSettings(formData),
    onSuccess: (data) => {
      queryClient.setQueryData([queryKeys.currentUserSettings], data);
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const data: UserSettingsResponse = err.response.data as UserSettingsResponse;
        queryClient.setQueryData([queryKeys.currentUserSettings], data);
      }
    },
  });
}
